import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, DollarSign, Users } from 'lucide-react';
export function Timeline() {
  const steps = [{
    day: 'Día 3',
    title: 'Tu demo está listo',
    icon: Smartphone,
    color: 'bg-blue-100 text-blue-600'
  }, {
    day: 'Día 5',
    title: 'Primer $20 por Zelle',
    icon: DollarSign,
    color: 'bg-green-100 text-green-600'
  }, {
    day: 'Día 7',
    title: '3 clientes en tu pipeline',
    icon: Users,
    color: 'bg-purple-100 text-purple-600'
  }];
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-205">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D1B0E]" data-id="element-208">
            📅 Tu Semana de Transformación
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto relative" data-id="element-209">
          {/* Vertical Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-[#D4A853]/30 rounded-full hidden md:block" data-id="element-210"></div>

          <div className="space-y-12 relative" data-id="element-211">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -50 : 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className={`flex flex-col md:flex-row items-center gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-212">
                {/* Content Side */}
                <div className="flex-1 text-center md:text-left w-full" data-id="element-213">
                  <div className={`bg-white p-6 rounded-2xl shadow-md border-l-4 border-[#E8614D] ${index % 2 === 0 ? 'md:text-right md:border-l-0 md:border-r-4' : ''}`} data-id="element-214">
                    <span className="inline-block px-3 py-1 bg-[#E8614D]/10 text-[#E8614D] font-bold rounded-full text-sm mb-2" data-id="element-215">
                      {step.day}
                    </span>
                    <h3 className="text-xl font-bold text-[#2D1B0E]" data-id="element-216">
                      {step.title}
                    </h3>
                  </div>
                </div>

                {/* Center Icon */}
                <div className="relative z-10 flex-shrink-0" data-id="element-217">
                  <div className={`w-16 h-16 rounded-full ${step.color} flex items-center justify-center shadow-lg border-4 border-white`} data-id="element-218">
                    <step.icon className="w-8 h-8" data-id="element-219" />
                  </div>
                </div>

                {/* Empty Side for Balance */}
                <div className="flex-1 hidden md:block" data-id="element-220"></div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-16 bg-white p-6 rounded-2xl shadow-sm border border-gray-100 text-center max-w-2xl mx-auto" data-id="element-221">
            <p className="text-[#2D1B0E]/80 font-medium" data-id="element-222">
              Lee Capítulo 1: Primer Reel en 15 minutos → Capítulos 2-3: Setup +
              Prompts → Capítulo 4: Mensaje 3DM a groups →{' '}
              <span className="text-[#E8614D] font-bold" data-id="element-223">Primer cliente</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}